enum configActionType {
    SET_MENU_ITEMS = 'SET_MENU_ITEMS',
    SET_TOKEN_NOT_NULL = 'SET_TOKEN_NOT_NULL',
    TOGGLE_LOADING = 'TOGGLE_LOADING',
    SET_DEBUG_MODE = 'SET_DEBUG_MODE',
    SET_PUBLIC_KEY = 'SET_PUBLIC_KEY',
}

export default configActionType